import { Row, Col, Form, Button, Modal, Card } from 'react-bootstrap';
import "./EditOrderModal.css"
import { useState } from 'react';
import Swal from "sweetalert2";
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCirclePlus, faCircleNotch  } from "@fortawesome/free-solid-svg-icons";

//LOG FUNCTION
import { storeOrderLog } from "../../Helper_Library.js";

const EditOrderModal = ({ show, requestClose, orderID }) => {

    //ENV VARIABLE
    const apiUrl = process.env.REACT_APP_API_URL;
    const backendAPI_Key = process.env.REACT_APP_API_KEY;

    //SESSION OBJECT
    const sessionUser = JSON.parse(sessionStorage.getItem("userSession"));

    //INPUTS CONTROLS
    const [customer, setCustomer] = useState(null);
    const [model, setModel] = useState(null);
    const [serialNumber, setSerialNumber] = useState(null);
    const [failure, setFailure] = useState(null);
    const [personContact, setPersonContact] = useState(null);
    const [personContactData, setPersonContactData] = useState(null);
    const [address, setAddress] = useState(null);

    //
    const [technicalName, setTechnicalName] = useState(null);
    const [serviceInvoice, setServiceInvoice] = useState(null);
    const [userTechnicalListing, setUserTechnicalListing] = useState([]);

    //
    const [technicalReport, setTechnicalReport] = useState(null);
    const [counterDevice, setcounterDevice] = useState(null);
    const [serviceType, setServiceType] = useState(null);
    const [notes, setNotes] = useState(null);

    //
    const [waitingFlag, setWaitingFlag] = useState(false);

    //
    
    //
    const [objOrder, setObjOrder] = useState([]);


    function getCurrentDateTimeInArgentina() {

        const now = new Date();
        const argentinaTime = new Date(now.toLocaleString('en-US', { timeZone: 'America/Argentina/Buenos_Aires' }));

        const year = argentinaTime.getFullYear();
        const month = String(argentinaTime.getMonth() + 1).padStart(2, '0');
        const day = String(argentinaTime.getDate()).padStart(2, '0');
        const hours = String(argentinaTime.getHours()).padStart(2, '0');
        const minutes = String(argentinaTime.getMinutes()).padStart(2, '0');

        return `${year}-${month}-${day} ${hours}:${minutes}`;

    }//

    const editOrder = async () => {

        //MAIN VALIDATION
        if(!customer || !model || !serialNumber || !failure || !personContact || !address) {

            //Show message sweet alert
            Swal.fire({
                title: "Datos Faltantes",
                text: "Faltan datos obligatorios por completar.",
                icon: "warning",
                confirmButtonText: "OK"
            });

            return;
        }//

        //DATOS MINIMOS
        if(serialNumber.length < 4) { 

            //Show message sweet alert
            Swal.fire({
                title: "Datos Mínimos",
                text: "El campo Nro de Serie debe tener mínimo 4 caracteres.",
                icon: "warning",
                confirmButtonText: "OK"
            });

            return;

        }


        //
        const metadata = {
            "issuesDate": objOrder.issuesDate,
            "status": objOrder.status,
            "customer":customer,
            "model": model ? model.replace(/[\t\\']/g, '').trim() : "",
            "serialNumber":serialNumber ? serialNumber.replace(/[\t\\']/g, '').trim() : "",
            "failure": failure ? failure.replace(/[\t\\']/g, '').trim() : "",
            "personContact": personContact ? personContact.replace(/[\t\\']/g, '').trim() : "",
            "personContactData": personContactData ? personContactData.replace(/[\t\\']/g, '').trim() : "",
            "address": address ? address.replace(/[\t\\']/g, '').trim() : "",
            "notes": notes ? notes.replace(/[\t\\']/g, '').trim() : ""

        };
        
        
        //CONDICIONALES
        if(technicalName) { metadata.tecnico = technicalName; }
        if(technicalReport) { metadata.technicalReport = technicalReport.replace(/[\t\n\r\\']/g, ''); }
        if(counterDevice) { metadata.counterDevice = counterDevice.replace(/[\t\\']/g, '').trim(); }
        if(serviceInvoice) { metadata.serviceInvoice = serviceInvoice; }
        if(serviceType) { metadata.serviceType = serviceType; }

        //
        if(objOrder.customerSignature) { metadata.customerSignature = objOrder.customerSignature; }
        if(objOrder.signerName) { metadata.signerName = objOrder.signerName.replace(/[\t\\']/g, '').trim(); }
        if(objOrder.signerDNI) { metadata.signerDNI = objOrder.signerDNI.replace(/[\t\\']/g, '').trim(); }

        
        //
        const requestBody ="{\"metadata\":\"" + JSON.stringify(metadata).replace(/"/g, '\\"') + "\"}";
        

        const endpoint = "updateOrder?orderID=" + orderID;

        const response = await fetch(apiUrl + endpoint,
        {
            method: "POST",
            headers: {"Content-Type": "application/json", "X-API-KEY" : backendAPI_Key},
            body: requestBody
        });

        const responseContent = await response.json();

        //STORE CHANGE DETAILS
        let changeNotes = "";


        if(objOrder.model !== metadata.model) { changeNotes = changeNotes + "Modelo: " + objOrder.model + " > "  + metadata.model + "\n"; }
        if(objOrder.serialNumber !== metadata.serialNumber) { changeNotes = changeNotes + "Serial: " + objOrder.serialNumber + " > "  + metadata.serialNumber + "\n"; }
        if(failure && objOrder.failure !== metadata.failure) { changeNotes = changeNotes + "Falla: " + objOrder.failure + " > "  + metadata.failure + "\n"; }
        if(personContact && objOrder.personContact !== metadata.personContact) { changeNotes = changeNotes + "Persona Contacto: " + objOrder.personContact + " > "  + metadata.personContact + "\n"; }
        if(personContactData && objOrder.personContactData !== metadata.personContactData) { changeNotes = changeNotes + "Datos Contacto: " + objOrder.personContactData + " > "  + metadata.personContactData + "\n"; }
        if(address && objOrder.address !== metadata.address) { changeNotes = changeNotes + "Dirección: " + objOrder.address + " > "  + metadata.address + "\n"; }
        if(serviceInvoice && objOrder.serviceInvoice !== metadata.serviceInvoice) { changeNotes = changeNotes + "Serv. Facturable: " + objOrder.serviceInvoice + " > "  + metadata.serviceInvoice + "\n"; }
        if(technicalName && objOrder.tecnico !== metadata.tecnico) { changeNotes = changeNotes + "Técnico: " + objOrder.tecnico + " > "  + metadata.tecnico + "\n"; }
        if(notes && objOrder.notes !== metadata.notes) { changeNotes = changeNotes + "Notas: " + objOrder.notes + " > "  + metadata.notes + "\n"; }
        

        if(changeNotes !== "") { changeNotes = "Se cambiaron los siguientes campos:\n\n" + changeNotes; }
        else { changeNotes = "No se realizaron cambios sobre ningún campo."  }


        //STORE LOG INFORMATION
        storeOrderLog(responseContent.order_id, sessionUser.customer_name, "Edición del Servicio", changeNotes);

        //Show message sweet alert
        Swal.fire({
            title: "¡Éxito!",
            text: "Operación realizada exitosamente.",
            icon: "success",
            confirmButtonText: "OK"
        });


        //CLOSE MODAL
        requestClose(false);

    } //

    const requestOrderInfo = async () =>{


        //
        setWaitingFlag(true);


        let endpoint = "getOrderByID?order_id=" + orderID;

        let response = await fetch(apiUrl + endpoint,
        {
            method: "GET",
            headers: {"Content-Type": "application/json", "X-API-KEY" : backendAPI_Key}
        });

        let responseContent = await response.json();

        let metadata = JSON.parse(responseContent.metadata);
        setObjOrder(metadata);

        //
        setCustomer(metadata.customer);
        setModel(metadata.model);
        setSerialNumber(metadata.serialNumber);
        setFailure(metadata.failure);
        setPersonContact(metadata.personContact);
        setPersonContactData(metadata.personContactData);
        setAddress(metadata.address);
        setNotes(metadata.notes);

        if(!metadata.notes) {setNotes("");}

        //
        setServiceInvoice(metadata.serviceInvoice);
        setTechnicalName(metadata.tecnico);

        //
        setTechnicalReport(metadata.technicalReport);
        setcounterDevice(metadata.counterDevice);
        setServiceType(metadata.serviceType);


        //
        //GET USERS
        endpoint = "getUsersListing";

        response = await fetch(apiUrl + endpoint,
        {
            method: "GET",
            headers: {"Content-Type": "application/json", "X-API-KEY" : backendAPI_Key}
        });

        responseContent = await response.json();

        //
        setWaitingFlag(false);

        setUserTechnicalListing(responseContent);



    } //END FUNCTION

    

    return (
        <>
        <Modal show={show} onShow={requestOrderInfo} onHide={requestClose} className={'mainOrderModal'} size="lg">
            <Modal.Header closeButton style={{borderTop:'10px solid #404661'}}>
                <Modal.Title className={'newOrderTitle'}>Editar Orden de Servicio</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>

                    {waitingFlag ? 
                        <Row style={{textAlign:"center", color: "darkred"}}>
                            <Col>
                                <FontAwesomeIcon 
                                    spin
                                    icon={faCircleNotch } 
                                    style={{}} 
                                /> <span>Obteniendo datos, por favor espere...</span>
                            </Col>
                        </Row>
                        : 
                    (
                     <>
                     <Card variant="primary">
                        <Card.Header style={{backgroundColor: "#404661", color: "white"}}>Datos del Servicio</Card.Header>
                        <Card.Body>

                            
                            <Row>
                                <Col xs={12}>
                                    <Form.Group>
                                        <Form.Label className={'newOrderlabels'}>Cliente</Form.Label>
                                        <Form.Control 
                                                type="text" 
                                                value={customer} 
                                                disabled="disabled"
                                        />
                                        <br />
                                    </Form.Group>
                                </Col>
                                <Col xs={6}>
                                    <Form.Group>
                                        <Form.Label className={'newOrderlabels'}>Modelo</Form.Label>
                                        <Form.Control 
                                        type="text" 
                                        placeholder="Modelo del equipo..."
                                        value={model}
                                        maxLength={80} 
                                        onChange={(event)=> setModel(event.target.value)} /><br />
                                    </Form.Group>
                                </Col>
                                <Col xs={6}>
                                    <Form.Group>
                                        <Form.Label className={'newOrderlabels'}>N° de Serie</Form.Label>
                                        <Form.Control 
                                        type="text" 
                                        placeholder="Número de Serie" 
                                        value={serialNumber}
                                        maxLength={80} 
                                        onChange={(event)=> setSerialNumber(event.target.value)} /><br />
                                    </Form.Group>
                                </Col>

                                <Col xs={12}>
                                    <Form.Group>
                                        <Form.Label className={'newOrderlabels'}>Falla / Detalles</Form.Label>
                                        <Form.Control 
                                        type="text" 
                                        placeholder="Falla del equipo" 
                                        value={failure}
                                        maxLength={200} 
                                        onChange={(event)=> setFailure(event.target.value)} /><br />
                                    </Form.Group>
                                </Col>

                                <Col xs={6}>
                                    <Form.Group>
                                        <Form.Label className={'newOrderlabels'}>Persona Contacto</Form.Label>
                                        <Form.Control 
                                        type="text" 
                                        placeholder="Nombre y apellido del solicitante..." 
                                        value={personContact}
                                        maxLength={80} 
                                        onChange={(event)=> setPersonContact(event.target.value)} /><br />
                                    </Form.Group>
                                </Col>

                                <Col xs={6}>
                                    <Form.Group>
                                        <Form.Label>Datos del Contacto</Form.Label>
                                        <Form.Control 
                                        type="text" 
                                        placeholder="Teléfono / Email" 
                                        value={personContactData}
                                        maxLength={80} 
                                        onChange={(event)=> setPersonContactData(event.target.value)} /><br />
                                    </Form.Group>
                                </Col>

                                <Col xs={12}>
                                    <Form.Group>
                                        <Form.Label>Dirección del Servicio</Form.Label>
                                        <Form.Control 
                                        type="text" 
                                        placeholder="Direccion..." 
                                        value={address}
                                        maxLength={200} 
                                        onChange={(event)=> setAddress(event.target.value)} /><br />
                                    </Form.Group>
                                </Col>
                                <Col xs={12}>
                                    <Form.Group>
                                        <Form.Label>Notas / Observaciones</Form.Label>
                                        <Form.Control 
                                        type="text" 
                                        placeholder="Notas varias..." 
                                        value={notes}
                                        maxLength={200} 
                                        onChange={(event)=> setNotes(event.target.value)} /><br />
                                    </Form.Group>
                                </Col>
                            </Row>

                            
                        </Card.Body>
                    </Card>

                    <br />

                    { objOrder.status === "Técnico asignado" || objOrder.status === "Servicio en pausa" ? (
                    <Card variant="primary">
                        <Card.Header style={{backgroundColor: "#404661", color: "white"}}>Datos del Técnico</Card.Header>
                        <Card.Body>

                            <Col xs={12}>
                                <Form.Label className='newOrderlabels'>Servicio Facturable: </Form.Label>
                                <Form.Select value={serviceInvoice} style={{fontSize:"13px"}} onChange={(e)=>{setServiceInvoice(e.target.value); }} >
                                    <option style={{fontSize:"14px"}} value="">Seleccione...</option>
                                    <option style={{fontSize:"14px"}} value="No">No</option>
                                    <option style={{fontSize:"14px"}} value="Si">Si</option>
                                </Form.Select>
                            </Col>
                            <br />
                            <Col xs={12}>
                                <Form.Group>
                                    <Form.Label className='newOrderlabels'>Listado de Técnicos</Form.Label>
                                    <Form.Select value={technicalName} style={{fontSize:"13px"}} onChange={(e)=>{setTechnicalName(e.target.value); }} >
                                        <option style={{fontSize:"14px"}}>Seleccione...</option>
                                        {userTechnicalListing.map((item)=>{

                                            return(
                                                (item.groupname === "Técnicos" ? (
                                                    <option style={{fontSize:"14px"}}>{item.customer_name}</option>
                                                ) : "" )
                                            )

                                        })}
            
                                    </Form.Select> <br />
                                </Form.Group>
                            </Col>
                        
                        </Card.Body>
                    </Card>

                    ) : "" }

                    <br />

                    { objOrder.technicalReport ? (
                        <Card variant="primary">
                            <Card.Header style={{backgroundColor: "#404661", color: "white"}}>Datos del Informe</Card.Header>
                            <Card.Body>

                                <Row>
                                    <Col xs={12}>
                                        <Form.Label className={'newOrderlabels'}>Informe Técnico</Form.Label>
                                        <Form.Control as="textarea" rows={5} onChange={(event)=> setTechnicalReport(event.target.value)} value={technicalReport} /><br />
                                    </Col>

                                    <Col xs={6}>
                                        <Form.Group>
                                            <Form.Label className={'newOrderlabels'}>Contador</Form.Label>
                                            <Form.Control 
                                            type="text" 
                                            placeholder="Direccion..." 
                                            value={counterDevice}
                                            maxLength={200} 
                                            onChange={(event)=> setcounterDevice(event.target.value)} /><br />
                                        </Form.Group>
                                    </Col>

                                    <Col xs={6}>
                                        <Form.Label className={'newOrderlabels'}>Tipo de Servicio</Form.Label>
                                            <Form.Select value={serviceType} style={{fontSize:"13px"}} onChange={(e)=>{setServiceType(e.target.value); }} >
                                                <option style={{fontSize:"14px"}} value="">Seleccione...</option>
                                                <option style={{fontSize:"14px"}} value="Remoto">Remoto</option>
                                                <option style={{fontSize:"14px"}} value="Presencial">Presencial</option>
                                            </Form.Select>
                                    </Col>
                                </Row>
                            
                            </Card.Body>
                        </Card>
                    ) : "" }

                    </>
                    )}
                </Form>
            </Modal.Body>
            <Modal.Footer>
            <Button variant="danger" onClick={requestClose} size='sm'>
                Cerrar Ventana
            </Button>
            <Button 
                variant="success" 
                size='sm'
                onClick={editOrder}
                >

                Guardar Datos
            </Button>
            </Modal.Footer>
        </Modal>

        </>
    );
}

export default EditOrderModal;